import * as React from 'react';
import { useSelector } from 'react-redux';
import { Experiment } from '@cian/experiments/ab';

import { DownloadAppBannerContainer } from '../DownloadAppBannerContainer';
import { LinkToFullVersionContainer } from '../LinkToFullVersionContainer';
import { MobileFooterLayout } from '../../components/MobileFooterLayout';
import { CianLogo } from '../../components/CianLogo';
import { MOBILE_FOOTER_TYPES } from '../../constants/footerTypes';
import { IApplicationState } from '../../types/redux';
import { useIsSearchPage } from '../../hooks/useIsSearchPage';
import { AUD_MOBILE_REDESIGN_OBJECTCARD } from '../../constants/experiments';

export const MobileFooterContainer: React.FC = () => {
  const footerType = useSelector((state: IApplicationState) => state.footerType);
  const isSearchPage = useIsSearchPage();

  if (!MOBILE_FOOTER_TYPES.includes(footerType)) {
    return null;
  }

  if (isSearchPage) {
    return (
      <>
        <Experiment name={AUD_MOBILE_REDESIGN_OBJECTCARD} group="A" default>
          <MobileFooterLayout type={footerType}>
            <DownloadAppBannerContainer />
            <CianLogo />
            <LinkToFullVersionContainer />
          </MobileFooterLayout>
        </Experiment>

        <Experiment name={AUD_MOBILE_REDESIGN_OBJECTCARD} group="B">
          <MobileFooterLayout type={footerType} isRedesign>
            <DownloadAppBannerContainer isRedesign />
            <LinkToFullVersionContainer isRedesign />
            <CianLogo />
          </MobileFooterLayout>
        </Experiment>
      </>
    );
  }

  return (
    <MobileFooterLayout type={footerType}>
      <DownloadAppBannerContainer />
      <CianLogo />
      <LinkToFullVersionContainer />
    </MobileFooterLayout>
  );
};
